__turbopack_context__.v({
  "ButtonLg": "icon-btn-module__dLIzhG__ButtonLg",
});
